<template>
    <div>
        <div class="chartRow">
            <div class="chartColLeft">
                <Form ref="formInline" :label-width="125" label-position="left">
                    <FormItem label="员工姓名:">
                        <span>孙士奇</span>
                    </FormItem>
                    <FormItem label="职位信息:">
                        <span>主任专员-HRBP</span>
                    </FormItem>
                    <FormItem label="部门:">
                        <span>人力资源部</span>
                    </FormItem>
                    <FormItem label="直属主管:">
                        <span>06897875</span>
                    </FormItem>
                    <FormItem label="评估名称:">
                        <span>2021胜任力评估</span>
                    </FormItem>
                    <FormItem label="发起日期:">
                        <span>2021-10-28</span>
                    </FormItem>
                    <FormItem label="应完成日期:">
                        <span>2021-12-28</span>
                    </FormItem>
                    <FormItem label="当前状态:">
                        <span>评估完成</span>
                    </FormItem>
                </Form>
            </div>
            <div class="chartCol">
                <div id="radarChart" :style="{width: '94%', height: '320px'}"></div>
            </div>
            <div class="chartColRight">
                <div id="gaugeChart" :style="{width: '96%', height: '320px'}"></div>
            </div>
        </div>
    </div>
</template>

<script>
import './westerosa.js'
export default {
    data(){
        return{

        }
    },
    mounted(){
        this.radarChart()
        this.gaugeChart()
    },
    methods:{
        radarChart(){
            // 基于准备好的dom，初始化echarts实例
            let myChart = this.$echarts.init(document.getElementById('radarChart'),'westerosa')
            // 绘制图表
            myChart.setOption({
                legend: {
                    data: ['目标分值', '评估开始', '评估完成'],
                    bottom: 0,
                },
                radar: {
                    indicator: [
                        { name: '决策力量', max: 6500 },
                        { name: '追求结果', max: 16000 },
                        { name: '人才培养', max: 30000 },
                        { name: '慧眼识人', max: 38000 },
                        { name: '激励他人', max: 52000 },
                        { name: '管理勇气', max: 25000 }
                    ],
                    
                    // shape: 'circle',
                    startAngle: 60, //旋转角度
                    bottom:20,
                        name:{
                            textStyle:{color:'#373737'}
                        }
                        
                },
                series: [
                    {
                    name: 'Budget vs spending',
                    type: 'radar',
                    data: [
                        {
                        value: [4200, 3000, 20000, 35000, 50000, 18000],
                        name: '目标分值'
                        },
                        {
                        value: [5000, 14000, 28000, 26000, 42000, 21000],
                        name: '评估开始'
                        },
                        {
                        value: [2000, 6000, 18000, 22000, 48000, 11000],
                        name: '评估完成'
                        }
                    ]
                    }
                ]
            });
            window.addEventListener("resize",function(){
                myChart.resize();
            });
        },
        gaugeChart(){
            // 基于准备好的dom，初始化echarts实例
            let myChart = this.$echarts.init(document.getElementById('gaugeChart'),'westeros')
            // 绘制图表
            myChart.setOption({
                tooltip: {
                    formatter: '{a} <br/>{b} : {c}%'
                },
                 title: [
                    {
                        text: "胜任力得分",
                        y: "90%",
                        x: "center",
                        textStyle: {
                        fontSize: 16,
                        fontFamily: "yueyuan",
                        color: "#373737",
                        },
                    },
                    
                    ],
                series: [
                    {
                    name: 'Pressure',
                    type: 'gauge',
                    axisLine: {
                        lineStyle: {
                        width: 20,
                        color: [
                            [0.3, '#67e0e3'],
                            [0.7, '#37a2da'],
                            [1, '#fd666d']
                        ]
                        }
                    },
                    min: 0,
                    max: 5,
                    interval: 0.5,
                    detail: {
                        formatter: '{value}'
                    },
                    data: [
                        {
                        value: 3.69,
                        }
                    ]
                    }
                ]
            });
            window.addEventListener("resize",function(){
                myChart.resize();
            });
        }
    }
}
</script>

<style scoped>
.chartRow {
    display: flex;
}
.chartColLeft {
    width: 30%;
    padding: 30px 20px;
    box-sizing: border-box;
}
.chartCol {
    width: 35%;
}
.chartColRight {
    width: 30%;
}
.ivu-form-item {
    margin-bottom: 2px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/bipage/components/ComChart.vue